import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { NOTIFICATIONS } from '../../constants';
import './notification.scss';

const Notification = props => {
  const ICON = NOTIFICATIONS.ICON[props.type];
  return (
    <motion.div
      initial={{ opacity: 0, y: '-30%', x: '-50%' }}
      animate={{ opacity: 1, y: '0%', x: '-50%' }}
      exit={{ opacity: 0, y: '-30%', x: '-50%' }}
      className="notification fixed flex shadow-lg rounded l-50 bg-white overflow-hidden">
      <div
        className="flex items-center px-2"
        style={{ backgroundColor: NOTIFICATIONS.COLOR[props.type] }}>
        <ICON />
      </div>
      <div className="px-2 py-2">
        <h3 className="font-bold text-base m-0">
          {NOTIFICATIONS.TITLE[props.type]}
        </h3>
        <p className="text-sm mt-2 mb-0">{props.message}</p>
      </div>
    </motion.div>
  );
};

Notification.propTypes = {
  type: PropTypes.oneOf(Object.keys(NOTIFICATIONS.TYPE)),
  message: PropTypes.string,
};

export default  Notification;
